module.exports = __webpack_public_path__ + "img/home-grid-info-h-jianixiuyuan.91ea0d53.png";